import './fareextrar/style';
import FormStructure from './fareextrar/form_structure';

export default FormStructure;